import { DndContext, type DragEndEvent, MouseSensor, TouchSensor, type UniqueIdentifier, useSensor } from '@dnd-kit/core';
import { restrictToParentElement, restrictToVerticalAxis } from '@dnd-kit/modifiers';
import { SortableContext } from '@dnd-kit/sortable';
export const QuizListSortableContainer = ({
  children,
  items,
  onDragEnd
}: {
  children: React.ReactNode;
  items: UniqueIdentifier[];
  onDragEnd: (event: DragEndEvent) => void;
}) => {
  const mouseSensor = useSensor(MouseSensor);
  const touchSensor = useSensor(TouchSensor, {
    activationConstraint: {
      delay: 100,
      tolerance: 10
    }
  });
  return <DndContext modifiers={[restrictToVerticalAxis, restrictToParentElement]} onDragEnd={onDragEnd} sensors={[mouseSensor, touchSensor]} data-sentry-element="DndContext" data-sentry-component="QuizListSortableContainer" data-sentry-source-file="QuizListSortableContainer.tsx">
      <SortableContext items={items} data-sentry-element="SortableContext" data-sentry-source-file="QuizListSortableContainer.tsx">
        <div className="mb-lg flex flex-col gap-sm">{children}</div>
      </SortableContext>
    </DndContext>;
};